function Skeleton() {
  return (
    <div className='skeleton'>
      <div className='line'></div>
      <div className='line'></div>
      <div className='line'></div>
      <div className='line'></div>
    </div>
  );
}

export default Skeleton;
